<template>
  <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <el-form-item label="归档组" prop="title">
        <el-input v-model="form.title" placeholder="请输入标签组名称" />
      </el-form-item>
      <el-form-item label="会话标签" prop="tags">
        <div v-for="(item,index) in form.tags" :key="index" class="input-box">
          <el-input v-model="item.title" placeholder="请输入标会话签组名称" />
          <i class="el-icon-plus" @click="handleAddItem"></i>
          <i class="el-icon-minus" @click="handleDeleteItem(index)" v-if="form.tags.length > 1"></i>
        </div>
      </el-form-item>
      <el-form-item label="状态" prop="isEnable">
        <el-switch v-model="form.isEnable" :active-value="true" :inactive-value="false"></el-switch> {{form.isEnable?'启用':'禁用'}}
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import custServiceArchiveGroupApi from '@/api/customer/custServiceArchiveGroup'
function initFormBean() {
  const formBean = {
    title: null,
    isEnable: false,
    tags: [{ title: '', isEnable: true, archiveGroupId: 0 }],
  }
  return formBean
}

export default {
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        title: [{ required: true, message: '请输入标签组名称', trigger: 'blur' }],
        tags: [{ required: true, message: '请输入标会话签组名称', trigger: 'blur' }],
        isEnable: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false
    }
  },
  created() {

  },
  methods: {
    resetForm() {
      this.form = initFormBean()
    },
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = JSON.parse(JSON.stringify(row))
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },

    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let { tags } = this.form;
          let count = 0
          tags.forEach(item => {
            if (!item.title) return count = 1
          })
          if (count) return this.$message.error('请输入标会话签组名称')
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            custServiceArchiveGroupApi.update(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            custServiceArchiveGroupApi.create(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(data) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
    handleDeleteItem(index) {
      this.form.tags.splice(index, 1)
    },
    handleAddItem() {
      this.form.tags.push({ title: '', isEnable: true, archiveGroupId: 0 })
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}

.input-box {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  i {
    cursor: pointer;
  }
}

.input-box:last-child {
  margin-bottom: 0;
}

::v-deep .el-icon-plus,
.el-icon-minus {
  margin-left: 4px;
  color: #60b7dc;
}
</style>
